export const customV14 = [
  {
    name: 'customV2_startPageV2',
  },
  {
    name: 'customV2_policyPage',
  },
  {
    name: 'customV2_gender',
  },
  {
    name: 'customV2_name',
  },
  {
    name: 'customV2_age',
  },
  {
    name: 'customV2_breed',
  },
  {
    name: 'customV2_health',
  },
  {
    name: 'customV2_info_breed',
  },
  {
    name: 'customV2_potty',
  },
  {
    name: 'customV2_issues',
  },
  {
    name: 'customV2_walking_issues',
  },
  {
    name: 'customV2_activity',
  },
  {
    name: 'customV2_info_breed_2',
  },
  {
    name: 'customV2_command_1',
  },
  {
    name: 'customV2_command_2',
  },
  {
    name: 'customV2_command_3',
  },
  {
    name: 'customV2_training_time',
  },
  {
    name: 'customV2_training',
  },
  {
    name: 'customV2_creating_program',
  },
  {
    name: 'customV2_plan',
  },
  {
    name: 'customV2_email',
  },
];
